import { useState } from "react";
import { Link, Box, Text, Button } from "@chakra-ui/react";
import { Collapse } from "@chakra-ui/transition";
import { ExternalLinkIcon } from "@chakra-ui/icons";

const Skill = ({ movements }) =>
{
    const [show, setShow] = useState(false);
    const handleToggle = () => setShow(!show);
    return (
        <>
        {
            movements && movements.map(movement => (
                <Box key={movement.name}>
                <Link href={movement.link} isExternal>
                <Box>
                    <Text fontSize="lg" fontFamily="Museo Sans Bold">
                    {movement.name} <ExternalLinkIcon mx="2px" />
                    </Text> 
                </Box>
                </Link>
                <Collapse startingHeight={22} in={show}>
                {movement.description}
                </Collapse>
                <Button size="sm" onClick={handleToggle} mt="1rem">
                Mostrar {show ? "Menos" : "Más"}
                </Button>
                </Box>
            ))
        }
        </>
    );
};

export default Skill;